export class HistoryOutput {
    public UserId: number = 0;
    public UpdateDescription: string = ""; 
    public ServiceOrderUpload: string = "";

    constructor(data?: any) {
        this.UserId = data?.UserId ?? 0;
        this.UpdateDescription = data?.UpdateDescription ?? '';
        this.ServiceOrderUpload = data?.ServiceOrderUpload ?? '';
    }
}

export class HistoryInput {
    public Date: Date;
    public Username: string = '';
    public UpdateDescription: string = "";
    public ServiceOrderUpload: string = "";

    constructor(data?: any) {
        this.Date = data?.Date;
        this.Username = data?.Username ?? '';
        this.UpdateDescription = data?.UpdateDescription ?? '';
        this.ServiceOrderUpload = data?.ServiceOrderUpload ?? '';
    }
}

export interface CustomerHistoryDataOut {
  id: number;
  hasJsonData: boolean;
  username: string;
  userId: number;
  updateDescription: string;
  date: Date;
  previousMeterNumber: string;
  newMeterNumber: string;
  previousPhoneNumber: string;
  newPhoneNumber: string;
  previousEmail: string;
  newEmail: string;
  previousArea: string;
  previousAreaId: number | null;
  previousRegion: string;
  newArea: string;
  newAreaId: number | null;
  newRegion: string;
  previousBuildingSlrn: string;
  newBuildingSlrn: string;
  previousMeterSlrn: string;
  newMeterSlrn: string;
  previousTariff: string;
  newTariff: string;
  previousDt: string;
  newDt: string;
  previousFeeder: string;
  newFeeder: string;
  previousSubgeographicalRegion: string;
  newSubgeographicalRegion: string;
  previousGeographicalRegion: string;
  newGeographicalRegion: string;
  previousSubstation: string;
  newSubstation: string;
  previousSubstationFeeder: string;
  newSubstationFeeder: string;
  previousCustomerType: string;
  newCustomerType: string;
  previousCustomerPhase: string;
  newCustomerPhase: string;
  role: string;
  operatorEmail: string;
  previousAccountStatus: string;
  newAccountStatus: string;
}